module.exports = __webpack_public_path__ + "img/soda-puig.ae4b8ccb.png";